import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";

export const getTables = createAsyncThunk(
  "tables/get",
  async (_, { rejectWithValue }) => {
    return api
      .get("tables/")
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return rejectWithValue(err.response?.data);
      });
  },
  {
    condition: (params, { getState }) => {
      if (params?.ignoreCondition) {
        return true;
      }
      // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
      const { status } = selectTables(getState());
      if (status === "fulfilled" || status === "pending") {
        // Already fetched or in progress, don't need to re-fetch
        return false;
      }
    },
  }
);

const initialState = {
  status: "idle",
  data: [],
  error: null,
};

const tablesSlice = createSlice({
  name: "tables",
  initialState,
  reducers: {
    add: (state, action) => {
      state.data.push(action.payload);
    },
    set: (state, action) => {
      state.data = state.data.map((d) =>
        d.id === action.payload.id ? action.payload : d
      );
    },
    delete: (state, action) => {
      state.data = state.data.filter((d) => d.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTables.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getTables.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload;
      })
      .addCase(getTables.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase("auth/logout", () => initialState);
  },
});

export const tablesActions = tablesSlice.actions;

const _selectTables = (state) => state.tables;

export const selectTables = createSelector(
  [(state) => _selectTables(state)],
  (tables) => {
    const data = tables.data;
    const status = tables.status;
    const error = tables.error;
    const isLoading = status === "pending";
    return { data, status, error, isLoading };
  }
);

// memo ok
export const selectTablesNames = createSelector(
  [(state) => selectTables(state).data],
  (tables) => tables.map((d) => d.name)
);

export const selectSelectedTable = createSelector(
  [(state) => selectTables(state).data, (state, id) => id],
  (tables, id) => tables.find((d) => String(d.id) === id)
);

export default tablesSlice.reducer;
